import * as l from "react";
var ee = Object.defineProperty, a = Object.getOwnPropertySymbols, re = Object.prototype.hasOwnProperty, te = Object.prototype.propertyIsEnumerable, n = (t, e, r) => e in t ? ee(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, le = (t, e) => {
  for (var r in e || (e = {}))
    re.call(e, r) && n(t, r, e[r]);
  if (a)
    for (var r of a(e))
      te.call(e, r) && n(t, r, e[r]);
  return t;
};
function U1(t) {
  return /* @__PURE__ */ l.createElement("svg", le({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.196 4.256a4.369 4.369 0 016.179 6.178l-.54.539a.417.417 0 01-.589 0l-.589-.59a.417.417 0 010-.589l.539-.538a2.702 2.702 0 10-3.822-3.822L9.708 7.101a2.703 2.703 0 00-.271 3.505c.136.186.139.448-.024.611l-.59.59a.388.388 0 01-.574-.014 4.37 4.37 0 01.28-5.87l1.667-1.667zm1.717 4.461a.388.388 0 01.575.013 4.37 4.37 0 01-.28 5.87l-1.667 1.667a4.369 4.369 0 11-6.178-6.178L4.9 9.55a.417.417 0 01.59 0l.589.59a.417.417 0 010 .589l-.539.539a2.702 2.702 0 003.822 3.821l1.666-1.667a2.703 2.703 0 00.271-3.505c-.136-.186-.139-.448.024-.61l.59-.59z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /* @__PURE__ */ l.createElement("rect", {
    x: 1.615,
    y: 5.609,
    width: 3.556,
    height: 1.5,
    rx: 0.2,
    fill: "currentColor",
    fillOpacity: 0.5
  }), /* @__PURE__ */ l.createElement("rect", {
    width: 3.556,
    height: 1.5,
    rx: 0.2,
    transform: "matrix(0 1 1 0 5.622 1.602)",
    fill: "currentColor",
    fillOpacity: 0.5
  }));
}
var ae = Object.defineProperty, o = Object.getOwnPropertySymbols, ne = Object.prototype.hasOwnProperty, oe = Object.prototype.propertyIsEnumerable, i = (t, e, r) => e in t ? ae(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ie = (t, e) => {
  for (var r in e || (e = {}))
    ne.call(e, r) && i(t, r, e[r]);
  if (o)
    for (var r of o(e))
      oe.call(e, r) && i(t, r, e[r]);
  return t;
};
function X1(t) {
  return /* @__PURE__ */ l.createElement("svg", ie({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.498 2.502a7.499 7.499 0 100 14.998 7.499 7.499 0 000-14.998zm-9.165 7.5a9.165 9.165 0 1118.33 0 9.165 9.165 0 01-18.33 0zm10.58-2.831a1 1 0 111.415 1.414l-1.414 1.414 1.415 1.415a1 1 0 11-1.415 1.414L9.5 11.413l-1.415 1.415a1 1 0 01-1.414-1.415L8.085 10 6.672 8.586A1 1 0 118.086 7.17L9.5 8.585l1.414-1.414z",
    fill: "currentColor"
  }));
}
var pe = Object.defineProperty, p = Object.getOwnPropertySymbols, ce = Object.prototype.hasOwnProperty, fe = Object.prototype.propertyIsEnumerable, c = (t, e, r) => e in t ? pe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ve = (t, e) => {
  for (var r in e || (e = {}))
    ce.call(e, r) && c(t, r, e[r]);
  if (p)
    for (var r of p(e))
      fe.call(e, r) && c(t, r, e[r]);
  return t;
};
function q1(t) {
  return /* @__PURE__ */ l.createElement("svg", ve({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("g", null, /* @__PURE__ */ l.createElement("path", {
    d: "M7.25 9.058v1.45",
    stroke: "var(--TextQuaternary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ l.createElement("path", {
    d: "M3 6.891a.25.25 0 01.25-.25h8a.25.25 0 01.25.25v5.007a.25.25 0 01-.25.25h-8a.25.25 0 01-.25-.25V6.89z",
    stroke: "var(--TextQuaternary)"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 9.506c.483 0 .875-.352.875-.785 0-.434-.392-.785-.875-.785s-.875.351-.875.785c0 .433.392.785.875.785z",
    fill: "var(--TextQuaternary)"
  }), /* @__PURE__ */ l.createElement("path", {
    d: "M4.625 6.695V5.392C4.625 4.07 5.8 3 7.25 3s2.625 1.07 2.625 2.392v1.303",
    stroke: "var(--TextQuaternary)"
  })));
}
var se = Object.defineProperty, f = Object.getOwnPropertySymbols, de = Object.prototype.hasOwnProperty, ue = Object.prototype.propertyIsEnumerable, v = (t, e, r) => e in t ? se(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, we = (t, e) => {
  for (var r in e || (e = {}))
    de.call(e, r) && v(t, r, e[r]);
  if (f)
    for (var r of f(e))
      ue.call(e, r) && v(t, r, e[r]);
  return t;
};
function G1(t) {
  return /* @__PURE__ */ l.createElement("svg", we({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.423 1.028c-16.234 0-29.394 13.16-29.394 29.394 0 16.234 13.16 29.395 29.394 29.395a29.281 29.281 0 0019.325-7.246L67.696 70.52a1.547 1.547 0 102.188-2.188L51.969 50.417a29.29 29.29 0 007.848-19.995c0-16.234-13.16-29.394-29.394-29.394zm-26.3 29.394c0-14.525 11.775-26.3 26.3-26.3s26.3 11.775 26.3 26.3c0 14.526-11.775 26.3-26.3 26.3s-26.3-11.774-26.3-26.3z",
    fill: "currentColor",
    fillOpacity: 0.34
  }));
}
var me = Object.defineProperty, s = Object.getOwnPropertySymbols, he = Object.prototype.hasOwnProperty, _e = Object.prototype.propertyIsEnumerable, d = (t, e, r) => e in t ? me(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ge = (t, e) => {
  for (var r in e || (e = {}))
    he.call(e, r) && d(t, r, e[r]);
  if (s)
    for (var r of s(e))
      _e.call(e, r) && d(t, r, e[r]);
  return t;
};
function J1(t) {
  return /* @__PURE__ */ l.createElement("svg", ge({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fill: "currentColor",
    d: "M0 22h24V0z"
  }));
}
var Oe = Object.defineProperty, u = Object.getOwnPropertySymbols, Pe = Object.prototype.hasOwnProperty, Ce = Object.prototype.propertyIsEnumerable, w = (t, e, r) => e in t ? Oe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ye = (t, e) => {
  for (var r in e || (e = {}))
    Pe.call(e, r) && w(t, r, e[r]);
  if (u)
    for (var r of u(e))
      Ce.call(e, r) && w(t, r, e[r]);
  return t;
};
function K1(t) {
  return /* @__PURE__ */ l.createElement("svg", ye({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.86 5.413a.29.29 0 01-.001.41l-6.772 6.726a.58.58 0 01-.811.006L3.095 9.484a.29.29 0 01-.007-.41l.402-.417a.29.29 0 01.41-.007l2.773 2.678L13.043 5a.29.29 0 01.409.001l.408.411z",
    fill: "#fff"
  }));
}
var Ee = Object.defineProperty, m = Object.getOwnPropertySymbols, $e = Object.prototype.hasOwnProperty, Se = Object.prototype.propertyIsEnumerable, h = (t, e, r) => e in t ? Ee(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Le = (t, e) => {
  for (var r in e || (e = {}))
    $e.call(e, r) && h(t, r, e[r]);
  if (m)
    for (var r of m(e))
      Se.call(e, r) && h(t, r, e[r]);
  return t;
};
function Y1(t) {
  return /* @__PURE__ */ l.createElement("svg", Le({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31 14.42l2.758-1.379a2.083 2.083 0 011.863 0l2.759 1.38-.486-3.4a2.083 2.083 0 01.59-1.768l1.868-1.869-2.8-.43a2.083 2.083 0 01-1.575-1.187L9 2.977l-1.288 2.79a2.083 2.083 0 01-1.575 1.186l-2.8.431 1.87 1.87c.463.463.681 1.118.589 1.767l-.486 3.4zm3.503.112a.416.416 0 01.373 0l4.18 2.09a.833.833 0 001.198-.863l-.71-4.974a.416.416 0 01.118-.353L17.004 7.4a.833.833 0 00-.463-1.413l-4.425-.681a.417.417 0 01-.315-.237L9.756.639a.833.833 0 00-1.513 0L6.2 5.07a.417.417 0 01-.315.237l-4.426.68A.833.833 0 00.996 7.4l3.032 3.032a.417.417 0 01.118.353l-.71 4.974a.833.833 0 001.197.863l4.18-2.09z",
    fill: "currentColor",
    fillOpacity: 0.5
  }));
}
function k1(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    className: t.className,
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    d: "M20.2083 11.0833H15.875V12.75H20.2083V11.0833Z",
    fill: "#86909C"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.125 15.25V0.75H0.875V15.25H23.125ZM21.875 14V6.0625H2.125V14H21.875ZM21.875 2V4.39583H2.125V2H21.875Z",
    fill: "#86909C"
  }));
}
function er(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    d: "M37.3334 27.4862H18.6667V50.8195H37.3334V27.4862Z",
    stroke: "white",
    strokeWidth: "2"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 15.8195H44.3334L37.3334 27.4861H18.6667L11.6667 15.8195Z",
    stroke: "white",
    strokeWidth: "2"
  }), /* @__PURE__ */ l.createElement("path", {
    d: "M30.3334 34.4862H25.6667V41.4862H30.3334V34.4862Z",
    fill: "white"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3333 4.15283V11.1528H25.6667V4.15283H30.3333ZM42 6.48617V11.1528H37.3333V6.48617H42ZM18.6667 6.48617V11.1528H14V6.48617H18.6667Z",
    fill: "white"
  }));
}
function rr(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 23.3333H37.3334V46.6666H18.6667V23.3333Z",
    stroke: "white",
    strokeWidth: "2"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 11.6666H44.3334L37.3334 23.3333H18.6667L11.6667 11.6666Z",
    stroke: "white",
    strokeWidth: "2"
  }), /* @__PURE__ */ l.createElement("path", {
    d: "M30.3334 30.3333H25.6667V37.3333H30.3334V30.3333Z",
    fill: "white"
  }));
}
function tr(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "6.75",
    stroke: "#8A8B91",
    strokeWidth: "1.5"
  }), /* @__PURE__ */ l.createElement("rect", {
    x: "6",
    y: "9.2",
    width: "8",
    height: "1.6",
    rx: "0.2",
    fill: "currentColor",
    fillOpacity: "0.5"
  }));
}
var xe = Object.defineProperty, _ = Object.getOwnPropertySymbols, be = Object.prototype.hasOwnProperty, Me = Object.prototype.propertyIsEnumerable, g = (t, e, r) => e in t ? xe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ve = (t, e) => {
  for (var r in e || (e = {}))
    be.call(e, r) && g(t, r, e[r]);
  if (_)
    for (var r of _(e))
      Me.call(e, r) && g(t, r, e[r]);
  return t;
};
function lr(t) {
  return /* @__PURE__ */ l.createElement("svg", Ve({
    width: "11",
    height: "10",
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94225 3.09926L8.91994 6.07695C9.0013 6.15831 9.0013 6.29022 8.91994 6.37158L8.33068 6.96083C8.24932 7.04219 8.11741 7.04219 8.03605 6.96083L5.50031 4.42509L2.96457 6.96083C2.88321 7.04219 2.7513 7.04219 2.66994 6.96083L2.08068 6.37158C1.99932 6.29022 1.99932 6.15831 2.08068 6.07695L5.05837 3.09926C5.30245 2.85518 5.69817 2.85518 5.94225 3.09926Z",
    fill: "currentColor"
  }));
}
var Re = Object.defineProperty, O = Object.getOwnPropertySymbols, je = Object.prototype.hasOwnProperty, Ie = Object.prototype.propertyIsEnumerable, P = (t, e, r) => e in t ? Re(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, He = (t, e) => {
  for (var r in e || (e = {}))
    je.call(e, r) && P(t, r, e[r]);
  if (O)
    for (var r of O(e))
      Ie.call(e, r) && P(t, r, e[r]);
  return t;
};
function ar(t) {
  return /* @__PURE__ */ l.createElement("svg", He({
    width: "11",
    height: "10",
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05824 6.90026L2.08055 3.92257C1.99919 3.84121 1.99919 3.7093 2.08055 3.62794L2.66981 3.03869C2.75117 2.95733 2.88307 2.95733 2.96443 3.03869L5.50018 5.57443L8.03592 3.03869C8.11728 2.95733 8.24919 2.95733 8.33055 3.03869L8.91981 3.62794C9.00116 3.7093 9.00116 3.84121 8.91981 3.92257L5.94212 6.90026C5.69804 7.14434 5.30231 7.14434 5.05824 6.90026Z",
    fill: "currentColor"
  }));
}
var Be = Object.defineProperty, C = Object.getOwnPropertySymbols, ze = Object.prototype.hasOwnProperty, Ze = Object.prototype.propertyIsEnumerable, y = (t, e, r) => e in t ? Be(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Fe = (t, e) => {
  for (var r in e || (e = {}))
    ze.call(e, r) && y(t, r, e[r]);
  if (C)
    for (var r of C(e))
      Ze.call(e, r) && y(t, r, e[r]);
  return t;
};
function nr(t) {
  return /* @__PURE__ */ l.createElement("svg", Fe({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.241a1.5 1.5 0 00-1.5 1.5v9.75a1.5 1.5 0 001.5 1.5h12a1.5 1.5 0 001.5-1.5v-9.75a1.5 1.5 0 00-1.5-1.5H3zm0 1.5h12V6.43H3V4.74zM3 7.93h12v6.562H3V7.93zm7.125 3.937a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h3a.375.375 0 00.375-.375v-.75a.375.375 0 00-.375-.375h-3z",
    fill: "currentColor",
    fillOpacity: 0.5
  }));
}
var Ne = Object.defineProperty, E = Object.getOwnPropertySymbols, Ae = Object.prototype.hasOwnProperty, Te = Object.prototype.propertyIsEnumerable, $ = (t, e, r) => e in t ? Ne(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, We = (t, e) => {
  for (var r in e || (e = {}))
    Ae.call(e, r) && $(t, r, e[r]);
  if (E)
    for (var r of E(e))
      Te.call(e, r) && $(t, r, e[r]);
  return t;
};
function or(t) {
  return /* @__PURE__ */ l.createElement("svg", We({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.825 4.437a.375.375 0 00-.53 0l-.265.265a.375.375 0 000 .53l3.712 3.713a.375.375 0 00.53 0l.266-.265a.322.322 0 00.005-.005l3.442-3.442a.375.375 0 000-.53l-.265-.266a.375.375 0 00-.53 0L5.006 7.62 1.825 4.437z",
    fill: "#161823",
    fillOpacity: 0.5
  }));
}
var De = Object.defineProperty, S = Object.getOwnPropertySymbols, Qe = Object.prototype.hasOwnProperty, Ue = Object.prototype.propertyIsEnumerable, L = (t, e, r) => e in t ? De(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Xe = (t, e) => {
  for (var r in e || (e = {}))
    Qe.call(e, r) && L(t, r, e[r]);
  if (S)
    for (var r of S(e))
      Ue.call(e, r) && L(t, r, e[r]);
  return t;
};
function ir(t) {
  return /* @__PURE__ */ l.createElement("svg", Xe({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), /* @__PURE__ */ l.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ l.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /* @__PURE__ */ l.createElement("path", {
    fill: "#C2C6CC",
    d: "M21.75 4.5v15H2.25v-15h19.5zm-1.5 6.375H3.75V18h16.5v-7.125zm-2 3.625v2h-4v-2h4zm2-8.5H3.75v2.875h16.5V6z"
  })));
}
var qe = Object.defineProperty, x = Object.getOwnPropertySymbols, Ge = Object.prototype.hasOwnProperty, Je = Object.prototype.propertyIsEnumerable, b = (t, e, r) => e in t ? qe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ke = (t, e) => {
  for (var r in e || (e = {}))
    Ge.call(e, r) && b(t, r, e[r]);
  if (x)
    for (var r of x(e))
      Je.call(e, r) && b(t, r, e[r]);
  return t;
};
function pr(t) {
  return /* @__PURE__ */ l.createElement("svg", Ke({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    d: "M8 1a7 7 0 110 14A7 7 0 018 1z",
    fill: "#F2F3F5"
  }), /* @__PURE__ */ l.createElement("path", {
    d: "M10.164 5.357l.495.495a.4.4 0 010 .566L9.067 8.01l1.592 1.592a.4.4 0 010 .565l-.495.495a.4.4 0 01-.566 0L8.006 9.07l-1.59 1.592a.4.4 0 01-.566 0l-.495-.495a.4.4 0 010-.566l1.59-1.59-1.59-1.591a.4.4 0 010-.566l.495-.495a.4.4 0 01.566 0l1.59 1.59 1.592-1.59a.4.4 0 01.566 0z",
    fill: "#4E5969"
  }));
}
var Ye = Object.defineProperty, M = Object.getOwnPropertySymbols, ke = Object.prototype.hasOwnProperty, e1 = Object.prototype.propertyIsEnumerable, V = (t, e, r) => e in t ? Ye(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, r1 = (t, e) => {
  for (var r in e || (e = {}))
    ke.call(e, r) && V(t, r, e[r]);
  if (M)
    for (var r of M(e))
      e1.call(e, r) && V(t, r, e[r]);
  return t;
};
function cr(t) {
  return /* @__PURE__ */ l.createElement("svg", r1({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("g", {
    clipPath: "url(#online-banking_svg__clip0)"
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 9.116a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0zM9 .866a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zm1.957 4.584a.375.375 0 00-.52-.104l-.624.416a.375.375 0 00-.104.52l.515.772H6a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h5.625a.75.75 0 00.624-1.166L10.957 5.45zM6.375 9.679a.75.75 0 00-.624 1.166l1.292 1.938a.375.375 0 00.52.104l.624-.416a.375.375 0 00.104-.52l-.515-.772H12a.375.375 0 00.375-.375v-.75A.375.375 0 0012 9.679H6.375z",
    fill: "currentColor",
    fillOpacity: 0.5
  })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", {
    id: "online-banking_svg__clip0"
  }, /* @__PURE__ */ l.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .116)",
    d: "M0 0h18v18H0z"
  }))));
}
var t1 = Object.defineProperty, R = Object.getOwnPropertySymbols, l1 = Object.prototype.hasOwnProperty, a1 = Object.prototype.propertyIsEnumerable, j = (t, e, r) => e in t ? t1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, n1 = (t, e) => {
  for (var r in e || (e = {}))
    l1.call(e, r) && j(t, r, e[r]);
  if (R)
    for (var r of R(e))
      a1.call(e, r) && j(t, r, e[r]);
  return t;
};
function fr(t) {
  return /* @__PURE__ */ l.createElement("svg", n1({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.77 0h-22l24 20V2a2 2 0 00-2-2zm-6.373 7.324l-2.12-2.121-1.414 1.414 2.734 2.734.107.095A1.134 1.134 0 0017.2 9.35l5.563-5.562-1.414-1.414-4.952 4.95z",
    fill: "#2361F6"
  }));
}
var o1 = Object.defineProperty, I = Object.getOwnPropertySymbols, i1 = Object.prototype.hasOwnProperty, p1 = Object.prototype.propertyIsEnumerable, H = (t, e, r) => e in t ? o1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, c1 = (t, e) => {
  for (var r in e || (e = {}))
    i1.call(e, r) && H(t, r, e[r]);
  if (I)
    for (var r of I(e))
      p1.call(e, r) && H(t, r, e[r]);
  return t;
};
function vr(t) {
  return /* @__PURE__ */ l.createElement("svg", c1({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99 3.022a.38.38 0 00-.56-.034L3.278 4.115c-.369.36-.48.834-.328 1.229.497 1.292 1.608 3.563 3.842 5.75 2.233 2.189 4.551 3.277 5.87 3.764.404.149.886.04 1.255-.321l1.15-1.127a.362.362 0 00-.034-.55l-2.147-1.635a.381.381 0 00-.423-.025l-.424.25a2.285 2.285 0 01-2.748-.332L6.769 8.647a2.17 2.17 0 01-.338-2.693l.254-.415a.361.361 0 00-.025-.414L4.99 3.022zM3.37 1.949a1.9 1.9 0 012.805.17l1.67 2.103c.475.6.526 1.423.128 2.073l-.255.415c-.177.29-.13.66.113.898l2.522 2.47a.762.762 0 00.916.111l.425-.249a1.907 1.907 0 012.115.125l2.147 1.635c.89.679.972 1.968.174 2.749l-1.15 1.127c-.72.705-1.808 1.04-2.845.657-1.46-.539-3.978-1.725-6.402-4.1C3.31 9.76 2.098 7.294 1.547 5.863c-.39-1.015-.048-2.082.671-2.786l1.15-1.127z",
    fill: "currentColor",
    fillOpacity: 0.5
  }));
}
var f1 = Object.defineProperty, B = Object.getOwnPropertySymbols, v1 = Object.prototype.hasOwnProperty, s1 = Object.prototype.propertyIsEnumerable, z = (t, e, r) => e in t ? f1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, d1 = (t, e) => {
  for (var r in e || (e = {}))
    v1.call(e, r) && z(t, r, e[r]);
  if (B)
    for (var r of B(e))
      s1.call(e, r) && z(t, r, e[r]);
  return t;
};
function sr(t) {
  return /* @__PURE__ */ l.createElement("svg", d1({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 1.5C36.926 1.5 47 11.574 47 24S36.926 46.5 24.5 46.5 2 36.426 2 24 12.074 1.5 24.5 1.5z",
    fill: "#E8FFEA"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.833 17.184l1.149.964a1.5 1.5 0 01.184 2.113l-10.032 11.95a1.501 1.501 0 01-2.113.184l-2.298-1.928 10.996-13.098a1.501 1.501 0 012.114-.185z",
    fill: "#00B42A"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.875 25.112l1.006-1.118a1.5 1.5 0 012.093-.133l7.056 6.072-1.92 2.31a1.5 1.5 0 01-2.135.175l-5.968-5.169a1.5 1.5 0 01-.132-2.137z",
    fill: "#00B42A"
  }));
}
var u1 = Object.defineProperty, Z = Object.getOwnPropertySymbols, w1 = Object.prototype.hasOwnProperty, m1 = Object.prototype.propertyIsEnumerable, F = (t, e, r) => e in t ? u1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, h1 = (t, e) => {
  for (var r in e || (e = {}))
    w1.call(e, r) && F(t, r, e[r]);
  if (Z)
    for (var r of Z(e))
      m1.call(e, r) && F(t, r, e[r]);
  return t;
};
function dr(t) {
  return /* @__PURE__ */ l.createElement("svg", h1({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1.5c12.426 0 22.5 10.074 22.5 22.5S36.426 46.5 24 46.5 1.5 36.426 1.5 24 11.574 1.5 24 1.5z",
    fill: "#E8F3FF"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.748 19.84a.75.75 0 01.75.75v10.59l2.226.001a.84.84 0 01.84.84v2.688a.84.84 0 01-.84.84h-9.267a.84.84 0 01-.84-.84v-2.688a.84.84 0 01.84-.84l2.243-.001v-6.918h-.433a.84.84 0 01-.84-.84v-2.73a.84.84 0 01.84-.84h1.048a.748.748 0 01.135-.012h3.299zm-.439-7.36a.84.84 0 01.84.84v3.12a.84.84 0 01-.84.84h-3.12a.84.84 0 01-.84-.84v-3.12a.84.84 0 01.84-.84h3.12z",
    fill: "#165DFF"
  }));
}
var _1 = Object.defineProperty, N = Object.getOwnPropertySymbols, g1 = Object.prototype.hasOwnProperty, O1 = Object.prototype.propertyIsEnumerable, A = (t, e, r) => e in t ? _1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, P1 = (t, e) => {
  for (var r in e || (e = {}))
    g1.call(e, r) && A(t, r, e[r]);
  if (N)
    for (var r of N(e))
      O1.call(e, r) && A(t, r, e[r]);
  return t;
};
function ur(t) {
  return /* @__PURE__ */ l.createElement("svg", P1({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM.5 6a5.5 5.5 0 1111 0 5.5 5.5 0 01-11 0zm6.25-2a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-1 1.5a.25.25 0 00-.25.25V8.5c0 .138.112.25.25.25h.5a.25.25 0 00.25-.25V5.75a.25.25 0 00-.25-.25h-.5z",
    fill: "currentColor",
    fillOpacity: 0.34
  }));
}
var C1 = Object.defineProperty, T = Object.getOwnPropertySymbols, y1 = Object.prototype.hasOwnProperty, E1 = Object.prototype.propertyIsEnumerable, W = (t, e, r) => e in t ? C1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, $1 = (t, e) => {
  for (var r in e || (e = {}))
    y1.call(e, r) && W(t, r, e[r]);
  if (T)
    for (var r of T(e))
      E1.call(e, r) && W(t, r, e[r]);
  return t;
};
function wr(t) {
  return /* @__PURE__ */ l.createElement("svg", $1({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    d: "M24.5 46.5C36.926 46.5 47 36.426 47 24S36.926 1.5 24.5 1.5 2 11.574 2 24s10.074 22.5 22.5 22.5z",
    fill: "#FFF7E8"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.121 30.063c.69 0 1.25.56 1.25 1.25v3.25c0 .69-.56 1.25-1.25 1.25h-3.25c-.69 0-1.25-.56-1.25-1.25v-3.25c0-.69.56-1.25 1.25-1.25h3.25zm0-18.359c.69 0 1.25.56 1.25 1.25v13.15c0 .69-.56 1.25-1.25 1.25h-3.25c-.69 0-1.25-.56-1.25-1.25v-13.15c0-.69.56-1.25 1.25-1.25h3.25z",
    fill: "#FF7D00"
  }));
}
var S1 = Object.defineProperty, D = Object.getOwnPropertySymbols, L1 = Object.prototype.hasOwnProperty, x1 = Object.prototype.propertyIsEnumerable, Q = (t, e, r) => e in t ? S1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, b1 = (t, e) => {
  for (var r in e || (e = {}))
    L1.call(e, r) && Q(t, r, e[r]);
  if (D)
    for (var r of D(e))
      x1.call(e, r) && Q(t, r, e[r]);
  return t;
};
function mr(t) {
  return /* @__PURE__ */ l.createElement("svg", b1({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    d: "M24.2695 1.5C36.696 1.5 46.7695 11.5736 46.7695 24C46.7695 36.4265 36.696 46.5 24.2695 46.5C11.8431 46.5 1.76953 36.4265 1.76953 24C1.76953 11.5736 11.8431 1.5 24.2695 1.5Z",
    fill: "#FFECE8"
  }), /* @__PURE__ */ l.createElement("path", {
    d: "M30.7647 16.0712L32.2497 17.5561C32.7183 18.0248 32.7183 18.7846 32.2497 19.2532L27.4753 24.0267L32.2497 28.8009C32.7183 29.2695 32.7183 30.0293 32.2497 30.4979L30.7647 31.9828C30.2961 32.4515 29.5363 32.4515 29.0677 31.9828L24.2923 27.2082L19.5217 31.9811C19.0531 32.4497 18.2933 32.4497 17.8247 31.9811L16.3398 30.4962C15.8711 30.0275 15.8711 29.2677 16.3398 28.7991L21.1108 24.0267L16.3398 19.2549C15.8711 18.7863 15.8711 18.0265 16.3398 17.5579L17.8247 16.0729C18.2933 15.6043 19.0531 15.6043 19.5217 16.0729L24.2938 20.8452L29.0677 16.0712C29.5363 15.6026 30.2961 15.6026 30.7647 16.0712Z",
    fill: "#F53F3F"
  }));
}
var M1 = Object.defineProperty, U = Object.getOwnPropertySymbols, V1 = Object.prototype.hasOwnProperty, R1 = Object.prototype.propertyIsEnumerable, X = (t, e, r) => e in t ? M1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, j1 = (t, e) => {
  for (var r in e || (e = {}))
    V1.call(e, r) && X(t, r, e[r]);
  if (U)
    for (var r of U(e))
      R1.call(e, r) && X(t, r, e[r]);
  return t;
};
function hr(t) {
  return /* @__PURE__ */ l.createElement("svg", j1({
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "17",
    height: "16"
  }, /* @__PURE__ */ l.createElement("rect", {
    x: "0.56543",
    width: "16",
    height: "16",
    fill: "white"
  })), /* @__PURE__ */ l.createElement("g", {
    mask: "url(#mask0)"
  }), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2614 4.71153L8.56529 1.42285L2.86914 4.71153V11.2889L8.56529 14.5776L14.2614 11.2889V4.71153ZM8.56529 2.5772L13.2613 5.2892V10.7102L8.56529 13.4222L3.86829 10.7102V5.2892L8.56529 2.5772ZM8.56529 5.5002C7.18458 5.5002 6.06529 6.61949 6.06529 8.0002C6.06529 9.38091 7.18458 10.5002 8.56529 10.5002C9.946 10.5002 11.0653 9.38091 11.0653 8.0002C11.0653 6.61949 9.946 5.5002 8.56529 5.5002ZM8.56529 6.5002C9.39372 6.5002 10.0653 7.17177 10.0653 8.0002C10.0653 8.82863 9.39372 9.5002 8.56529 9.5002C7.73687 9.5002 7.06529 8.82863 7.06529 8.0002C7.06529 7.17177 7.73687 6.5002 8.56529 6.5002Z",
    fill: "#2C6BFF"
  }));
}
var I1 = Object.defineProperty, q = Object.getOwnPropertySymbols, H1 = Object.prototype.hasOwnProperty, B1 = Object.prototype.propertyIsEnumerable, G = (t, e, r) => e in t ? I1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, z1 = (t, e) => {
  for (var r in e || (e = {}))
    H1.call(e, r) && G(t, r, e[r]);
  if (q)
    for (var r of q(e))
      B1.call(e, r) && G(t, r, e[r]);
  return t;
};
function _r(t) {
  return /* @__PURE__ */ l.createElement("svg", z1({
    width: "102px",
    height: "102px",
    viewBox: "0 0 102 102",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, t), /* @__PURE__ */ l.createElement("g", {
    id: "loading-icon",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ l.createElement("path", {
    d: "M51,0 C79.1665222,0 102,22.8334778 102,51 C102,54.8659932 98.8659932,58 95,58 C91.1340068,58 88,54.8659932 88,51 C88,30.5654643 71.4345357,14 51,14 C30.5654643,14 14,30.5654643 14,51 C14,71.4345357 30.5654643,88 51,88 C57.2402138,88 63.2412601,86.4588928 68.5940919,83.5587872 L69.1271992,83.2642534 C72.4955926,81.3669316 76.7642981,82.5594708 78.6616199,85.9278641 C80.5589417,89.2962575 79.3664026,93.564963 75.9980092,95.4622848 C68.4280004,99.7262591 59.8710835,102 51,102 C22.8334778,102 0,79.1665222 0,51 C0,22.8334778 22.8334778,0 51,0 Z",
    id: "loading-icon",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
var Z1 = Object.defineProperty, J = Object.getOwnPropertySymbols, F1 = Object.prototype.hasOwnProperty, N1 = Object.prototype.propertyIsEnumerable, K = (t, e, r) => e in t ? Z1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, A1 = (t, e) => {
  for (var r in e || (e = {}))
    F1.call(e, r) && K(t, r, e[r]);
  if (J)
    for (var r of J(e))
      N1.call(e, r) && K(t, r, e[r]);
  return t;
};
function gr(t) {
  return /* @__PURE__ */ l.createElement("svg", A1({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33594 9.33374L6.66927 9.33374V6.66707L9.33594 6.66707V9.33374ZM14.668 9.33341H12.0013V6.66675H14.668V9.33341ZM1.33333 9.33374H4V6.66707H1.33333V9.33374Z",
    fill: "currentColor"
  }));
}
function Or(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "12",
    height: "13",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: t.onClick
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.51472 2 1.5 4.01472 1.5 6.5C1.5 8.98528 3.51472 11 6 11C8.48528 11 10.5 8.98528 10.5 6.5C10.5 4.01472 8.48528 2 6 2ZM0.5 6.5C0.5 3.46243 2.96243 1 6 1C9.03757 1 11.5 3.46243 11.5 6.5C11.5 9.53757 9.03757 12 6 12C2.96243 12 0.5 9.53757 0.5 6.5ZM6.75 4.5C6.75 4.91421 6.41421 5.25 6 5.25C5.58579 5.25 5.25 4.91421 5.25 4.5C5.25 4.08579 5.58579 3.75 6 3.75C6.41421 3.75 6.75 4.08579 6.75 4.5ZM5.75 6C5.61193 6 5.5 6.11193 5.5 6.25V9C5.5 9.13807 5.61193 9.25 5.75 9.25H6.25C6.38807 9.25 6.5 9.13807 6.5 9V6.25C6.5 6.11193 6.38807 6 6.25 6H5.75Z",
    fill: "#161823",
    fillOpacity: "0.5"
  }));
}
function Pr(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7232 8L8.26365 3.54044C8.13347 3.41027 8.13347 3.19921 8.26365 3.06904L8.73505 2.59763C8.86523 2.46746 9.07628 2.46746 9.20646 2.59763L14.1374 7.5286C14.3978 7.78894 14.3978 8.21106 14.1374 8.4714L9.20646 13.4024C9.07628 13.5325 8.86523 13.5325 8.73505 13.4024L8.26365 12.931C8.13347 12.8008 8.13347 12.5897 8.26365 12.4596L12.7232 8Z",
    fill: "#161823",
    fillOpacity: "0.5"
  }));
}
function Cr(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27679 8L7.73635 3.54044C7.86653 3.41027 7.86653 3.19921 7.73635 3.06904L7.26495 2.59763C7.13477 2.46746 6.92372 2.46746 6.79354 2.59763L1.86258 7.5286C1.60223 7.78894 1.60223 8.21106 1.86258 8.4714L6.79354 13.4024C6.92372 13.5325 7.13477 13.5325 7.26495 13.4024L7.73635 12.931C7.86653 12.8008 7.86653 12.5897 7.73635 12.4596L3.27679 8Z",
    fill: "#161823",
    fillOpacity: "0.5"
  }));
}
function yr(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.25 3.25C5.25 3.11193 5.36193 3 5.5 3H6.5C6.63807 3 6.75 3.11193 6.75 3.25V6.25C6.75 6.38807 6.63807 6.5 6.5 6.5H5.5C5.36193 6.5 5.25 6.38807 5.25 6.25V3.25ZM6 9.25C6.48325 9.25 6.875 8.85825 6.875 8.375C6.875 7.89175 6.48325 7.5 6 7.5C5.51675 7.5 5.125 7.89175 5.125 8.375C5.125 8.85825 5.51675 9.25 6 9.25Z",
    fill: "#FF4C3A"
  }));
}
function Er(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5ZM5.5 3.75V6C5.5 6.27614 5.72386 6.5 6 6.5H8.25C8.38807 6.5 8.5 6.38807 8.5 6.25V5.75C8.5 5.61193 8.38807 5.5 8.25 5.5H6.5V3.75C6.5 3.61193 6.38807 3.5 6.25 3.5H5.75C5.61193 3.5 5.5 3.61193 5.5 3.75Z",
    fill: "#FACE15"
  }));
}
function $r(t) {
  return /* @__PURE__ */ l.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 13.4166C10.5445 13.4166 13.4173 10.5438 13.4173 6.99998C13.4173 3.45615 10.5445 0.583313 7.00065 0.583313C3.45682 0.583313 0.583984 3.45615 0.583984 6.99998C0.583984 10.5438 3.45682 13.4166 7.00065 13.4166ZM4.21708 6.44264C4.33098 6.32874 4.51565 6.32874 4.62956 6.44264L5.99824 7.81132L9.33557 4.47399C9.44947 4.36009 9.63414 4.36009 9.74805 4.47399L10.5168 5.2427C10.6307 5.35661 10.6307 5.54128 10.5168 5.65518L7.17943 8.99251L6.41072 9.76122C6.18291 9.98903 5.81356 9.98903 5.58576 9.76122L4.81705 8.99251L3.44837 7.62383C3.33446 7.50993 3.33447 7.32526 3.44837 7.21135L4.21708 6.44264Z",
    fill: "#4FAB7E"
  }));
}
var T1 = Object.defineProperty, Y = Object.getOwnPropertySymbols, W1 = Object.prototype.hasOwnProperty, D1 = Object.prototype.propertyIsEnumerable, k = (t, e, r) => e in t ? T1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Q1 = (t, e) => {
  for (var r in e || (e = {}))
    W1.call(e, r) && k(t, r, e[r]);
  if (Y)
    for (var r of Y(e))
      D1.call(e, r) && k(t, r, e[r]);
  return t;
};
function Sr(t) {
  return /* @__PURE__ */ l.createElement("svg", Q1({
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ l.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43953 1.02245C7.64246 1.14067 7.76199 1.36267 7.74897 1.59716C7.67215 2.98028 7.71408 4.24273 7.93034 5.21599C8.03686 5.69538 8.17636 6.06544 8.33923 6.34156C8.71709 5.151 9.32395 4.13697 10.2158 3.54245C10.417 3.40831 10.6776 3.4023 10.8848 3.52703C11.0918 3.65166 11.2085 3.88449 11.1843 4.12492L11.1843 4.12544L11.1841 4.12714L11.183 4.13963C11.182 4.15144 11.1804 4.17007 11.1786 4.19488C11.1749 4.24453 11.1702 4.31863 11.1664 4.41192C11.1588 4.59914 11.1552 4.86029 11.1709 5.15415C11.2033 5.76428 11.315 6.42454 11.5738 6.87743C12.3419 8.22179 12.0853 9.91414 11.4339 11.217C11.0419 12.001 10.2933 12.6302 9.43565 13.059C8.56986 13.4919 7.5369 13.75 6.49993 13.75C3.80133 13.75 1.88672 12.3947 1.23739 10.8699C0.805802 9.85633 0.818168 8.70066 1.02477 7.7401C1.12922 7.25451 1.2873 6.79885 1.47993 6.41293C1.66766 6.03684 1.90931 5.68458 2.2032 5.44946C2.3694 5.31649 2.59185 5.27725 2.79352 5.34532C2.99519 5.4134 3.14835 5.57942 3.19998 5.78592C3.32152 6.27208 3.48887 6.7911 3.68633 7.22823C3.82028 4.55486 4.71289 2.37006 6.78696 1.03676C6.98452 0.909763 7.23659 0.904235 7.43953 1.02245ZM9.96083 5.68887C9.67901 6.20615 9.45359 6.85587 9.30025 7.62257C9.26303 7.8087 9.14324 7.96782 8.97467 8.05506C8.80609 8.14231 8.60701 8.14822 8.43356 8.07113C7.44964 7.63385 6.95643 6.5957 6.7101 5.48713C6.54139 4.72787 6.46928 3.85353 6.46371 2.93039C5.28423 4.22936 4.81488 6.16234 4.93673 8.72026C4.94486 8.89099 4.88272 9.0576 4.76477 9.1813C4.64682 9.305 4.48336 9.375 4.31244 9.375C3.89689 9.375 3.56443 9.16612 3.32593 8.93771C3.08658 8.70847 2.88891 8.4111 2.72634 8.10765C2.61132 7.89296 2.50586 7.65993 2.41037 7.41965C2.34699 7.60027 2.29127 7.79632 2.24682 8.00295C2.07528 8.80049 2.08766 9.67608 2.38746 10.3801C2.80271 11.3553 4.19844 12.5 6.49993 12.5C7.33791 12.5 8.17994 12.2893 8.87663 11.941C9.58147 11.5886 10.0829 11.124 10.3159 10.658C10.8651 9.55945 10.9702 8.34071 10.4885 7.49757C10.1705 6.9411 10.0258 6.27044 9.96083 5.68887Z",
    fill: "#161823"
  }));
}
export {
  Pr as Arrow,
  ar as ArrowDown,
  lr as ArrowUp,
  nr as BankCard,
  Sr as BankHot,
  or as BottomSelect,
  ir as CardLogoPlaceHolder,
  k1 as CardLogoPlaceHolder2,
  pr as Clear,
  mr as Failed,
  rr as FlashOff,
  er as FlashOn,
  hr as Ic,
  Or as Info,
  yr as Invalid,
  Cr as LeftArrow,
  U1 as Link,
  _r as LoadingIcon,
  X1 as MarkCircle,
  gr as More,
  cr as OnlineBanking,
  fr as PcSelected,
  q1 as Pci,
  vr as Phone,
  tr as Remove,
  G1 as SearchBig,
  K1 as Selected,
  J1 as SelectedBackground,
  Y1 as Star,
  sr as Success,
  dr as Time,
  ur as Tip,
  $r as Valid,
  Er as Validating,
  wr as Warning
};
